/* unplugin-vue-components disabled */import script from "./PropsAddModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropsAddModal.vue?vue&type=script&setup=true&lang=ts"

import "./PropsAddModal.vue?vue&type=style&index=0&id=6149d6c4&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6149d6c4"]])

export default __exports__